class Platform {

	get DESKTOP() { return 'desktop'; }
	get TABLET() { return 'tablet'; }
	get MOBILE() { return 'mobile'; }

}

export default new Platform();
